import React, { Component } from 'react'
import { GET_LIST } from 'react-admin'

import MenuItem from '@material-ui/core/MenuItem';

import { SelectInput } from '../Inputs'
import dataProvider from '../../utils/dataProvider'


export class TechnicalDataInput extends Component {

    constructor(props) {
        super(props);

        this.state = { choices: [] }
    }

    componentDidMount() {
        const params = {
            pagination: {
                page: 1,
                perPage: 1000
            },
            sort: {
                field: 'name',
                order: 'ASC'
            },
            filter: {
                datasheet_type: this.props.schemaId
            }
        }
        dataProvider(GET_LIST, 'datos-tecnicos', params)
            .then(response => {
                this.setState({ choices: response.data })
            })
            .catch((e) => {
                console.error(e);
            });
    }

    renderChildren() {
        if (this.state.choices.length === 0){
            return <MenuItem value={''}></MenuItem>
        } else {
            return this.state.choices.map((op) => {
                return <MenuItem key={op.id} value={op.id}>{op.name}</MenuItem>
            })
        }
    }

    render() {
        return (
            <SelectInput {...this.props}>
                {this.renderChildren()}
            </SelectInput>
        )
    }
}
